//import { Cta } from "./components/Cta";
import { useEffect } from "react";
import { FAQ } from "../components/FAQ";
//import { Features } from "./components/Features";
import { Footer } from "../components/Footer";
import { Hero } from "../components/Hero";
import { HowItWorks } from "../components/HowItWorks";
import PageWithNavbar from "../components/PageWithNavbar";
import { Newsletter } from "../components/Newsletter";
import { PricingHomePage } from "../components/PricingHomePage";
import { ScrollToTop } from "../components/ScrollToTop";
import { Services } from "../components/Services";
//import { Sponsors } from "./components/Sponsors";
// import { Team } from "./components/Team";
// import { Testimonials } from "./components/Testimonials";
// Home page component with scroll-to-section support

const HomePage = () => {
  // Scroll to section if query param is present
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const scrollTo = params.get("scrollTo");
    if (scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(scrollTo);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // slight delay to ensure DOM is ready
    }
  }, []);
  return (
    <PageWithNavbar>
      <Hero scrollTarget='pricing' />
      {/* <Sponsors /> */}
      <Services />
      {/* <About /> */}
      <HowItWorks />
      {/*<Features />*/}
      {/*<Cta />*/}
      {/* <Testimonials /> */}
      {/* <Team /> */}
      <PricingHomePage />
      <Newsletter />
      <FAQ />
      <Footer />
      <ScrollToTop />
    </PageWithNavbar>
  );
};

export default HomePage;